export default {
  getUid: state => state.uid,
  getErrorState: state => state.errorState,
  getIsAuth: state => state.isAuth,
  getMenus: state => state.menus,
  getLocale: state => state.locale,
  getParams: state => state.params,
  getGMT: state => state.gmt,
  getUserEtcInfos: state => state.userEtcInfos,
  getMainPath: state => state.mainPath,
};



// WEBPACK FOOTER //
// ./src/vuex/getters.js